import {
  Component,
  ElementRef,
  forwardRef,
  HostListener,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { ProductPayloadService } from '../../product/product-payload/product-payload.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true,
    },
  ],
})
export class FileUploadComponent implements ControlValueAccessor, Validator {
  @Input() fileNames: string[] = [];
  public filesForm = this.fb.group({
    files: new FormControl<File[]>([], {
      nonNullable: true,
    }),
  });
  filesLabel = 'Ajouter des fichiers';
  filesErrorLabel = 'La taille combinée des fichiers dépasse la limite';
  files: File[] = [];

  onChange: (file: File[]) => void = () => {};

  constructor(
    private host: ElementRef<HTMLInputElement>,
    private readonly productPayloadService: ProductPayloadService,
    private fb: FormBuilder
  ) {}

  registerOnChange(fn: (files: File[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {}

  validate(control: AbstractControl): ValidationErrors | null {
    return this.filesForm.valid
      ? null
      : {
          invalidForm: {
            valid: false,
            message: 'imageForm fields are invalid',
          },
        };
  }

  writeValue(value: any): void {
    this.host.nativeElement.value = '';
    this.files = [];
    if (value) {
    } else {
      this.filesForm.reset();
    }
  }

  @HostListener('change', ['$event.target.files']) emitFiles(
    files: FileList
  ): void {
    if (files) {
      const newFiles = Array.from(files);
      this.files = [...(this.files || []), ...newFiles];
      const newFilenames: string[] = newFiles.map((file) => file.name);
      this.fileNames = [...(this.fileNames || []), ...newFilenames];
      this.onChange(this.files);
    }
  }

  delete(fileName: string): void {
    const addedFile = this.files.find((file) => file.name == fileName);
    if (addedFile != undefined) {
      this.files = this.files.filter((file) => file.name != fileName);
      this.fileNames = this.fileNames.filter((name) => name != fileName);
      this.onChange(this.files);
    } else {
      this.productPayloadService
        .deletePayloadFile(fileName)
        .subscribe(
          () =>
            (this.fileNames = this.fileNames.filter((name) => name != fileName))
        );
    }
  }
}
